module.exports = __webpack_public_path__ + "img/22.fd1fe2eb.jpg";